import { render, staticRenderFns } from "./SystemConfig.vue?vue&type=template&id=1ab092f4&scoped=true&"
import script from "./SystemConfig.vue?vue&type=script&lang=js&"
export * from "./SystemConfig.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfig.vue?vue&type=style&index=0&id=1ab092f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab092f4",
  null
  
)

component.options.__file = "SystemConfig.vue"
export default component.exports